import React, {useEffect, useMemo, useRef, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAngleDown,
    faAngleUp,
    faArrowDownWideShort,
    faArrowRotateRight,
    faArrowUpWideShort
} from "@fortawesome/free-solid-svg-icons";

import axios from 'util/axios';
import {useSelector} from "react-redux";

import {useTranslation} from "react-i18next";

import {getURLParam} from "util";

import Pagination, {SetPager} from "util/component/Pagination/v2";
import SearchableSelect from "util/component/SearchableSelect";

const VIEW_PAGE = 20;

const getList = async (userId, SetList) => {
    let result = null;
    try {
        const response = await axios.post(process.env.REACT_APP_API + "/pcsReview/retrieveReviewSheetList", {
            userId,
        });
        result = response.data.data.result;

        const reviewIngSortSequence = {
            "I": 1,
            "N": 2,
            "Y": 3,
            "NULL": 4
        }
        const reviewEndSortSequence = {
            "N": 1,
            "Y": 2,
        }
        result.sort((a, b) =>

            reviewIngSortSequence[a.reviewing] - reviewIngSortSequence[b.reviewing] ||

            reviewEndSortSequence[a.reviewEnd] - reviewEndSortSequence[b.reviewEnd] ||

            new Date(a.dueDate) - new Date(b.dueDate)
        )

    } catch (e) {
        console.error(e);
    }
    return [...result];
};

const SEARCH_INIT = {
    project: null,
    process: null,
    reviewing: null,
    reviewEnd: "N",
    dueDate: null,
    orderBy: null,
};

const HeaderContent = (props, ref) => {
    const [List, SetList] = useState([]);
    const userSelector = useSelector((store) => store.user);
    const {t} = useTranslation(["page"]);

    const ORIGIN_DATA = useRef(null);
    const SEARCHED_DATA = useRef(null);
    const [PAGER, SetPAGER] = useState(null);
    const [SEARCH_DATA, SET_SEARCH_DATA] = useState(SEARCH_INIT);
    const [projectSortState, setProjectSortState] = useState('ASC');
    const [dueDateSortState, setDueDateSortState] = useState('ASC');

    const initial = async () => {
        ORIGIN_DATA.current = await getList(userSelector.userId);
        SEARCHED_DATA.current = [...ORIGIN_DATA.current]?.filter((f) => f.reviewEnd === "N") || [];
        const pager = new SetPager(SEARCHED_DATA.current?.length, VIEW_PAGE);
        SetPAGER({data: pager});
    };

    useEffect(() => {

        if (!PAGER) return;
        const range = PAGER.data.getItemRange();
        let setData = [];
        for (let i = range.start; i < range.end; i++) {
            setData.push(SEARCHED_DATA.current[i]);
        }
        SetList(setData);
    }, [PAGER]);

    useEffect(() => {
        initial();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userSelector.userId, props]);

    const timeout = useRef(null);

    useEffect(() => {
        const {project, process, reviewing, reviewEnd} = SEARCH_DATA;
        clearTimeout(timeout.current);

        timeout.current = setTimeout(() => {
            // SEARCHED_DATA.current = [...ORIGIN_DATA?.current];
            SEARCHED_DATA.current = [...(ORIGIN_DATA?.current || [])];
            if (project) {
                if (project.length >= 2) {
                    SEARCHED_DATA.current = SEARCHED_DATA.current?.filter((f) => {
                        const regex = new RegExp(project, "gi");
                        return f.project.match(regex);
                    });
                }
            }
            if (process) {
                SEARCHED_DATA.current = SEARCHED_DATA.current?.filter((f) => f.process === process);
            }

            if (reviewing) {
                SEARCHED_DATA.current = SEARCHED_DATA.current?.filter((f) => f.reviewing === reviewing);
            }
            if (reviewEnd) {
                SEARCHED_DATA.current = SEARCHED_DATA.current?.filter((f) => f.reviewEnd === reviewEnd);
            }

            const pager = new SetPager(SEARCHED_DATA.current?.length, VIEW_PAGE);
            SetPAGER({data: pager});
        }, 500);
    }, [SEARCH_DATA]);


    const sortList = (sortKey) => {


        if (sortKey === 'date') {
            if (dueDateSortState === 'ASC') {
                setDueDateSortState('DESC')
            }
            if (dueDateSortState === 'DESC') {
                setDueDateSortState('ASC')
            }
        }

        if (sortKey === 'project') {
            if (projectSortState === 'ASC') {
                setProjectSortState('DESC')
            }
            if (projectSortState === 'DESC') {
                setProjectSortState('ASC')
            }
        }


        SEARCHED_DATA.current.sort((a, b) => {

                if (sortKey === 'date') {
                    return dueDateSortState === 'ASC' ? new Date(a.dueDate) - new Date(b.dueDate) :
                        new Date(b.dueDate) - new Date(a.dueDate)
                }

                if (sortKey === 'project') {
                    return projectSortState === 'ASC' ? a[sortKey].localeCompare(b[sortKey]) : b[sortKey].localeCompare(a[sortKey])
                }

            }
        )
        const range = PAGER.data.getItemRange();

        let setSortData = [];
        for (let i = range.start; i < range.end; i++) {
            setSortData.push(SEARCHED_DATA.current[i]);
        }
        SetList(setSortData);
    }


    const renderContent = useMemo(() => {
        let renderList = null;
        const indexNo = PAGER?.data.getIndexNO();
        if (List && List.length > 0) {
            renderList = List?.map((rowData, index) => {
                let reviewing;
                switch (rowData.reviewing) {
                    case "Y":
                        reviewing = <span className={"rev-end"}>Closed</span>;
                        break;
                    case "C":
                        reviewing = <span className={"rev-complete"}>Completed</span>;
                        break;
                    case "I":
                        reviewing = <span className={"rev-ing"}>In-progress</span>;
                        break;
                    case "N":
                        reviewing = <span className={"rev-not"}>Not started</span>;
                        break;
                    default:
                        reviewing = <span className={"rev"}>N/A</span>;
                }
                let reviewEnd;
                switch (rowData.reviewEnd) {
                    case "Y":
                        reviewEnd = <span className={"rev-disabled"}>Closed</span>;
                        break;
                    case "N":
                        reviewEnd = <span className={"rev-endabled"}>Started</span>;
                        break;
                    default:
                        reviewEnd = <span className={"rev"}>N/A</span>;
                }

                return (
                    <tr key={`reviewList${index}`} className={"clickable"} onClick={() => props?.action(rowData)}>
                        <td>{indexNo - index}</td>
                        <td>{rowData.project}</td>
                        <td>{rowData.process}</td>
                        <td>
                            <span className={rowData.tempYn === "Y" ? "bpl-temp-v2" : ""}>{rowData.revision}</span>
                        </td>
                        <td>{rowData.round}</td>
                        <td>{reviewing}</td>
                        <td>{reviewEnd}</td>
                        <td>{rowData.dueDate || "N/A"}</td>
                        <td>{rowData.ownerNm}</td>
                    </tr>
                );
            });
        } else {
            renderList = (
                <tr>
                    <td colSpan={9}>{t("noHistory")}</td>
                </tr>
            );
        }
        return renderList;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [List, props, t]);
    return (
        <>
            <h1 style={{marginBottom: "10px"}}>
                Comment
                <FontAwesomeIcon icon={faArrowRotateRight}
                                 style={{marginLeft: "15px", cursor: "pointer", fontSize: "1.2rem"}} onClick={initial}/>
            </h1>
            <div className={"table-responsive"}>
                <table className={`bpl-table-default small fixed text-center has-pagination review-list-table`}>
                    <colgroup>
                        <col width="50"/>
                        <col width="100"/>
                        <col width="100"/>
                        <col width="90"/>
                        <col width="70"/>
                        <col/>
                        <col/>
                        <col width="200"/>
                        <col width="200"/>
                    </colgroup>
                    <thead>
                    <tr>
                        <th>No.</th>
                        <th style={{cursor: "pointer"}} onClick={(e) => sortList('project')}>Project
                            {(
                                <>
                                    &nbsp;
                                    {projectSortState === 'DESC' ? (
                                        <FontAwesomeIcon icon={faArrowUpWideShort}/>
                                    ) : (
                                        <FontAwesomeIcon icon={faArrowDownWideShort}/>
                                    )}
                                </>
                            )}
                        </th>
                        <th>Process</th>
                        <th>Revision</th>
                        <th>Round</th>
                        <th>Comment Status</th>
                        <th>Document Status</th>
                        <th style={{cursor: "pointer"}} onClick={(e) => sortList('date')}>Due Date
                            {(
                                <>
                                    &nbsp;
                                    {dueDateSortState !== 'DESC' ? (
                                        <FontAwesomeIcon icon={faArrowUpWideShort}/>
                                    ) : (
                                        <FontAwesomeIcon icon={faArrowDownWideShort}/>
                                    )}
                                </>
                            )}
                        </th>
                        <th>Owner</th>
                    </tr>
                    <tr className={"search-row"}>
                        <td>
                            <button onClick={() => SET_SEARCH_DATA(SEARCH_INIT)}>Clear</button>
                        </td>
                        <td>
                            <input
                                type="text"
                                style={{textAlign: "center"}}
                                name="project"
                                placeholder="Search"
                                onChange={(e) =>
                                    SET_SEARCH_DATA((OLD) => ({
                                        ...OLD,
                                        project: e.target.value,
                                    }))
                                }
                                value={SEARCH_DATA.project || ""}
                            ></input>
                        </td>
                        <td>
                            <SearchableSelect
                                options={[
                                    {value: "USP", label: "USP"},
                                    {value: "DSP", label: "DSP"},
                                ]}
                                placeholder="Select"
                                onChange={(val) => SET_SEARCH_DATA((OLD) => ({...OLD, process: val.value}))}
                                value={SEARCH_DATA.process}
                                placeholderTextAlign="center"
                            />
                        </td>
                        <td></td>
                        <td></td>
                        <td>
                            <SearchableSelect
                                options={[
                                    {value: "I", label: "In-progress"},
                                    {value: "N", label: "Not Started"},
                                    {value: "Y", label: "Closed"},
                                    {value: "NULL", label: "N/A"},
                                    {value: null, label: "ALL"},
                                ]}
                                onChange={(val) => SET_SEARCH_DATA((OLD) => ({...OLD, reviewing: val.value}))}
                                value={SEARCH_DATA.reviewing}
                                placeholder="Select"
                                placeholderTextAlign="center"
                            />
                        </td>
                        <td>
                            <SearchableSelect
                                options={[
                                    {value: "N", label: "Started"},
                                    {value: "Y", label: "Closed"},
                                    {value: "", label: "ALL"},
                                ]}
                                onChange={(val) =>
                                    SET_SEARCH_DATA((OLD) => ({
                                        ...OLD,
                                        reviewEnd: val.value,
                                    }))
                                }
                                value={SEARCH_DATA.reviewEnd}
                                placeholder="Select"
                                placeholderTextAlign="center"
                            />
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                    </thead>
                    <tbody>{renderContent}</tbody>
                    <tfoot>
                    <tr>
                        <td colSpan={9}>
                            <Pagination data={PAGER?.data} set={(data) => SetPAGER({data: data, refresh: new Date()})}/>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </>
    );
};

const HeaderMenu = (props) => {
    const [Show, SetShow] = useState(true);

    const HandleShow = () => {
        SetShow(!Show);
    };

    useEffect(() => {
        const params = getURLParam();
        if (params?.geneCode) {
            SetShow(false);
            props.SetData(params);
        }
    }, []);

    const actionFunc = (rowData) => {
        const {geneCode, tempYn, revision ,ownerId} = rowData;
        SetShow(false);

        window.history.replaceState(null, "", `${window.location.pathname}?geneCode=${geneCode}&revision=${revision}&tempYn=${tempYn}&ownerId=${ownerId}`);
        props.SetData({geneCode, revision, tempYn, ownerId});
        window.location.reload();
    };

    return (
        <div className={"header-menu"}>
            <div className={"header-menu-content" + (Show ? "" : " hide")}>
                {Show && (
                    <div className="content">
                        <HeaderContent action={actionFunc}/>
                    </div>
                )}
            </div>
            <div className="header-menu-bar">
                <div className={"handle"} onClick={HandleShow}>
                    <div className={"inner"}>
                        <FontAwesomeIcon icon={Show ? faAngleUp : faAngleDown}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderMenu;
